var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"enter-active-class":"animated animated3 fadeInDown","leave-active-class":"animated animated3 fadeOutUp"}},[(_vm.visible)?_c('div',{staticClass:"alert message-wrap",class:_vm.alertClass,attrs:{"role":"alert"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.alertIcon)}}),_vm._v(" "+_vm._s(_vm.content)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b30fdfb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/message/index.vue
// module id = null
// module chunks = 